export default __webpack_public_path__ + "static/media/991.524a1dd0.gif";